import {createAction, props} from "@ngrx/store";
import {ActionType} from "@/ui/store/action.type";

export const ButtonLoaderAction = createAction(
  ActionType.BUTTON_LOADER,
  props<{load: boolean}>()
)
